import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
//function to show toast
export const showToast = ( type,msg) => {
  toast[type](msg, {
    position: "bottom-center",
    rtl: true,
  });
};
